<template>
  <div v-if="isShow">
    <div class="loadingComponent">
      <Loading color="#1989fa" />
    </div>
    <div class="bg" />
  </div>
</template>
<script>
import { Loading } from 'vant'
export default {
  components: {
    Loading
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped lang="scss">
.loadingComponent {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
}
.bg {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99998;
}
</style>
